import React, { forwardRef } from 'react'
import * as R from 'ramda'

import { Field } from '../../types'
import ErrorTooltip, { ErrorTooltipProps } from '../ErrorTooltip'

export interface PuiInputProps {
  readonly TooltipProps?: Partial<ErrorTooltipProps>
  readonly children: React.ReactElement<any, any>
  readonly field?: Field
}

const PuiInput = forwardRef(function PuiInput(
  { TooltipProps = {}, field, children, ...rest }: PuiInputProps,
  ref,
) {
  const {
    message,
    set,
    value,
    valid = true,
    open,
    validateTag,
    errorShouldBeShown = true,
  } = field || {}

  return (
    <ErrorTooltip
      disablePortal
      message={message}
      open={errorShouldBeShown && open && !valid}
      ref={ref}
      validateTag={validateTag}
      {...TooltipProps}
    >
      {!field || R.isEmpty(field)
        ? children
        : React.cloneElement(children, {
          error: children.props.error ?? !valid,
          value: children.props.value ?? value ?? '',
          onChange: children.props.onChange ?? set,
          ...rest,
        })}
    </ErrorTooltip>
  )
})

export default PuiInput
